export default "__VITE_ASSET__C8lg5Nh___"